import React, { FC, useEffect, useRef } from 'react'
import { IParamPick } from '../types'
import Modal from 'react-modal'
import cx from 'classnames'
import { useRouter } from 'next/router'
import { disableBodyScroll, clearAllBodyScrollLocks } from 'body-scroll-lock'
import PerfectScrollbar from 'react-perfect-scrollbar'
import Image from '../common/Image/Image'
import css from '../catalog/Product/ParamPicker/ParamPicker.module.scss'
import CloseIcon from '../../public/static/icons/close.svg'
import CheckIcon from '../../public/static/icons/check.svg'
import PercentSvg from '../../public/static/icons/icon-percent.svg'

const ParamPickerModal: FC<{
  picked: IParamPick
  onPick: (IParamPick) => void
  items: IParamPick[]
  open: boolean
  setOpen: React.Dispatch<React.SetStateAction<boolean>>
  title: string
  closeButtonText: string
}> = ({ picked, onPick, items, open, setOpen, title, closeButtonText }) => {
  if (!items) return null

  const itemsLocal = items.map((item) => ({
    ...item,
    name: item.item,
  }))

  const ref = useRef<Modal>()
  const router = useRouter()

  useEffect(() => {
    clearAllBodyScrollLocks(ref)
    setOpen(false)
  }, [router.asPath])

  useEffect(() => {
    if (!window && !document) {
      return
    }

    const storedScrollY = window.scrollY
    if (open) {
      disableBodyScroll(ref.current)
      document.body.style.setProperty('top', `${window.scrollY * -1}px`)
    } else {
      clearAllBodyScrollLocks(ref.current)
      document.body.style.setProperty('top', '')
      document.body.scrollTo(0, storedScrollY)
    }
  }, [open])

  return (
    <Modal
      ref={ref}
      isOpen={open}
      style={{
        content: {
          padding: 0,
          inset: 0,
          border: 0,
          zIndex: 10,
          borderRadius: null,
          top: 0,
          bottom: 0,
          left: 0,
          right: 0,
        },
        overlay: { zIndex: 10 },
      }}
    >
      <PerfectScrollbar options={{ swipeEasing: true }}>
        <div className={css.picker_mobile_top}>
          <button
            type="button"
            title={closeButtonText}
            onClick={() => setOpen(false)}
          >
            <CloseIcon />
          </button>
          <p>{title}:</p>
          <div className={css.empty} />
        </div>

        <ul className={css.picker_mobile_list}>
          {itemsLocal.map((item) => (
            <li
              key={item.id}
              className={cx(picked?.id === item.id && css.active)}
              onClick={() => {
                onPick(item)
                setOpen(false)
              }}
            >
              <div className={css.imgWrapper}>
                {item.priceOld !== item.price && (
                  <span className={css.icon}>
                    <PercentSvg />
                  </span>
                )}
                <figure className={css.image}>
                  <Image
                    src={item.image}
                    objectFit="cover"
                    width={38}
                    height={38}
                    loading="eager"
                  />
                </figure>
              </div>

              <p className={css.color_name}>{item.name}</p>

              <CheckIcon />
            </li>
          ))}
        </ul>
      </PerfectScrollbar>
    </Modal>
  )
}

export default ParamPickerModal
